import { DateConfig, SourceConfig, SourceConfigSchema } from 'types'
import { z } from 'zod'

export const serializeSourceConfigs = (
  src: SourceConfig[]
): z.input<typeof SourceConfigSchema>[] =>
  src.map((s) => ({
    type: s.type,
    source_id: s.sourceId,
    color: s.color,
    hidden: s.hidden ?? null,
    y_axis_range: s.yAxisRange ?? null,
  }))

type SerializedDateConfig = {
  mode: 'absolute' | 'relative'
  start_date?: string | null
  end_date?: string | null
  start_date_lookback?: { value: number; unit: string } | null
  end_date_lookback?: { value: number; unit: string } | null
  update_cadence_seconds?: number | null
}

export const serializeDateConfig = (dc: DateConfig): SerializedDateConfig => {
  if (dc.mode === 'absolute') {
    return {
      mode: 'absolute' as const,
      start_date: dc.startDate.toISOString(),
      end_date: dc.endDate.toISOString(),
      start_date_lookback: null,
      end_date_lookback: null,
      update_cadence_seconds: null,
    }
  }
  return {
    mode: 'relative' as const,
    start_date_lookback: dc.startDateLookback,
    end_date_lookback: dc.endDateLookback ?? null,
    update_cadence_seconds: dc.updateCadenceSeconds,
    start_date: null,
    end_date: null,
  }
}
